import { useMemo } from "react";
import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import { useSEO } from "@/hooks/useSEO";
import { useHashScroll } from "@/hooks/useHashScroll";
import { faqs } from "@/mocks/events";
import { eventList, sortByHeat } from "@/utils/content";
import HeroSection from "./components/HeroSection";
import CategoryStrip from "./components/CategoryStrip";
import FeaturedEvents from "./components/FeaturedEvents";
import TimelineReview from "./components/TimelineReview";
import Voices from "./components/Voices";
import FaqSection from "./components/FaqSection";
import SubscribeSection from "./components/SubscribeSection";

export default function Home() {
  useHashScroll();
  const jsonLd = useMemo(
    () => [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "热搜吃瓜",
        url: "https://hot-melon-watch.example.com/",
        description:
          "把热门事件的前因、经过与结果按时间线聚合在一起，完整复盘事件的来龙去脉。",
        inLanguage: "zh-CN",
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "热搜吃瓜",
        url: "https://hot-melon-watch.example.com/",
        email: "contact@hot-melon-watch.example.com",
        description: "专注热门事件梳理与时间线复盘的中文内容站点。",
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "精选热搜事件",
        itemListElement: sortByHeat()
          .slice(0, 6)
          .map((event, index) => ({
            "@type": "ListItem",
            position: index + 1,
            name: event.title,
            url: `https://hot-melon-watch.example.com/event/${event.slug}`,
          })),
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.q,
          acceptedAnswer: { "@type": "Answer", text: faq.a },
        })),
      },
    ],
    [],
  );

  useSEO({
    title: "热搜吃瓜 | 热门事件梳理·来龙去脉与时间线复盘",
    description:
      "热搜吃瓜专注热门事件梳理，把前因、经过与结果按时间线聚合在一起，完整复盘事件来龙去脉，不用来回切页面也能看懂热榜上的瓜。",
    keywords: "热搜吃瓜,热搜吃瓜事件梳理,热搜吃瓜来龙去脉,热搜吃瓜时间线,热搜吃瓜前因后果",
    path: "/",
    jsonLd,
  });

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="w-full flex-1">
        <HeroSection />
        <CategoryStrip />
        <FeaturedEvents />
        <TimelineReview />
        <Voices />
        <FaqSection />
        <SubscribeSection />
        <section className="w-full bg-background-50 pb-14 md:pb-20">
          <div className="mx-auto max-w-content px-4 md:px-6">
            <div className="flex flex-col items-start justify-between gap-4 rounded-lg border border-background-200 bg-background-100 p-6 md:flex-row md:items-center md:p-8">
              <div>
                <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                  已经收录 {eventList.length} 个事件的完整经过
                </h2>
                <p className="mt-2 text-sm text-foreground-600">
                  从瓜田总览进入，按分类或关键词快速找到你想看的那件事。
                </p>
              </div>
              <Link
                to="/events"
                className="flex items-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600"
              >
                浏览全部事件
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}